import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { FunctionBadgeContext } from '../../context';
import styles from './styles.module.css';
export function FunctionBadgeWrapper({ children, className }) {
    const [visible, setVisible] = useState(false);
    return (_jsx(FunctionBadgeContext.Provider, { value: { visible, setVisible }, children: _jsx("div", { className: className, "data-visible": visible || undefined, tabIndex: -1, children: _jsx("div", { className: styles.functionBadge, children: _jsx("div", { className: styles.functionRow, children: children }) }) }) }));
}
